import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Alert, AlertType } from '@core/common/common.entity';
import { AlertService } from '@core/services/alert.service';
const DISPLAY_IN_SECONDS = 8;
const SUCCESS_DISPLAY_MS = 3000;
@Component({
  standalone: false,
  // moduleId: module.id,
  selector: 'app-alert',
  templateUrl: 'alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  alerts: Alert[] = [];
  private lastTimeoutRef: any;
  constructor(private alertService: AlertService,
     private sanitizer: DomSanitizer,
  ) {
     // This is intentional
  }
  ngOnInit() {
    this.alertService.getAlert().subscribe((alert: Alert) => {
      if (!alert || Object.keys(alert).length === 0) {
        // clear alerts when an empty alert is received
        this.alerts = [];
        return;
      }
      // add alert to array
      else{
        if (alert.type === AlertType.Error) {
          this.alerts = [];
        }
        this.alerts = [alert];
      }
      // if (typeof alert.message === 'string') {
      //   alert.message = this.sanitizer.bypassSecurityTrustHtml(alert.message);
      // }
      // this.alerts.push(alert);
      if (this.lastTimeoutRef) {
        clearTimeout(this.lastTimeoutRef);
        this.lastTimeoutRef = null;
      }
     
      const defaultTimeout = alert.type === AlertType.Success ? SUCCESS_DISPLAY_MS : DISPLAY_IN_SECONDS * 1000;
      const timeout = alert.duration ?? defaultTimeout;
      this.lastTimeoutRef = setTimeout(() => this.removeAlert(alert), timeout);
    });
  }
  removeAlert(alert: Alert) {
    this.alerts = this.alerts.filter(x => x !== alert);
  }
  cssClass(alert: Alert): string | undefined {
    if (!alert) {
      return '';
    }
    // return css class based on alert type
    switch (alert.type) {
      case AlertType.Success:
        return 'alert alert-success';
      case AlertType.Error:
        return 'alert alert-danger';
      case AlertType.Info:
        return 'alert alert-info';
      case AlertType.Warning:
        return 'alert alert-warning';
    }
  }
}